import { Box, HStack, Text, VStack, Wrap } from '@chakra-ui/react'

export interface LegendSwatch { label: string; colorVar: string }
export interface GradientStop { colorVar: string; label?: string }
export type ChartLegendProps =
  | { variant: 'categorical'; items: LegendSwatch[] }
  | { variant: 'gradient'; stops: GradientStop[]; min: string; max: string; mid?: string; suppressed?: { colorVar: string; label: string } }
  | { variant: 'status'; items: { label: string; colorVar: string; icon?: React.ReactNode }[] }

const Swatch = ({ c }: { c: string }) => (
  <Box w="12px" h="12px" borderRadius="3px" flexShrink={0} style={{ background: c }} />
)

export function ChartLegend(props: ChartLegendProps) {
  if (props.variant === 'gradient') {
    const gradient = `linear-gradient(to right, ${props.stops.map((s) => s.colorVar).join(', ')})`
    return (
      <VStack align="stretch" gap={1}>
        <Box h="10px" borderRadius="4px" borderWidth="1px" borderColor="border" style={{ background: gradient }} />
        <HStack justify="space-between" fontFamily="mono" fontSize="10px" color="muted">
          <Text>{props.min}</Text>{!!props.mid && <Text>{props.mid}</Text>}<Text>{props.max}</Text>
        </HStack>
        {!!props.suppressed && (
          <HStack gap={2} fontSize="xs" color="muted"><Swatch c={props.suppressed.colorVar} /><Text>{props.suppressed.label}</Text></HStack>
        )}
      </VStack>
    )
  }
  return (
    <Wrap gapX={4} gapY={1}>
      {props.items.map((it) => (
        <HStack key={it.label} gap={2} fontSize="sm" color="ink">
          {'icon' in it && it.icon ? it.icon : <Swatch c={it.colorVar} />}
          <Text>{it.label}</Text>
        </HStack>
      ))}
    </Wrap>
  )
}
